import Button from 'admin/components/atoms/Buttons';
import ConfirmModal from 'admin/components/atoms/ConfirmModal';
import { components } from 'admin/schema/docs/api/admin';
import React from 'react';
import styled, { css } from 'styled-components';
import FA from '../../../../atoms/FontAwesome';
import convertAccountStatusToJapanese from '../utils';

type Customer = components['schemas']['Customer'];

type AccountStatus = {
  label: string;
  value: Customer['account_status'];
};

type AccountStatusModalProps = {
  customer: Customer;
  accountStatus: AccountStatus;
  isModalOpen: boolean;
  closeModal: () => void;
  onClose: (cashback: boolean) => void;
  onConfirm: () => void;
};

const ModalWrapper = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${spacing['32']};
    margin-top: ${spacing['24']};
  `}
`;

const ModalButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const Icon = styled(FA)`
  font-size: 16px;
`;

const ModalWarningMessage = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin-bottom: 0.5rem;

  p {
    margin-bottom: 0;
    color: #d75f48;
  }
`;

const CloseAccountStatusModal = ({
  isModalOpen,
  closeModal,
  onClose,
}: {
  isModalOpen: boolean;
  closeModal: () => void;
  onClose: (cashback: boolean) => void;
}) => {
  return (
    <ConfirmModal
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      title="退会処理を実行してもよろしいですか？"
      form={
        <ModalWrapper>
          <ModalWarningMessage>
            <Icon icon="exclamation-triangle" color="#D75F48" />
            <p>退会後に残高は元に戻すことが出来ません</p>
          </ModalWarningMessage>
          <ModalButtonGroup>
            <Button variant="neutral" onClick={closeModal}>
              キャンセル
            </Button>
            <Button variant="danger" onClick={() => onClose(false)}>
              退会（全額失効）
            </Button>
            <Button variant="danger" onClick={() => onClose(true)}>
              退会（マネー返金）
            </Button>
          </ModalButtonGroup>
        </ModalWrapper>
      }
    />
  );
};

const AccountStatusModal = ({
  customer,
  accountStatus,
  isModalOpen,
  closeModal,
  onClose,
  onConfirm,
}: AccountStatusModalProps) => {
  if (accountStatus.value === 'closed') {
    return (
      <CloseAccountStatusModal
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        onClose={onClose}
      />
    );
  }

  return (
    <ConfirmModal
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      title="アカウントの状態を変更します"
      form={
        <ModalWrapper>
          {customer.account_status &&
            `${convertAccountStatusToJapanese(customer.account_status)} → ${accountStatus.label}`}
          <ModalButtonGroup>
            <Button variant="neutral" onClick={closeModal}>
              キャンセル
            </Button>
            <Button variant="contained" onClick={onConfirm}>
              更新
            </Button>
          </ModalButtonGroup>
        </ModalWrapper>
      }
    />
  );
};

export default AccountStatusModal;
